<template>
    <div class="user">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>订单管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>订单列表</h2>
            </div>
        </div>
        <div class="page-content">

            <div class="table">
                <el-form :inline="true" align="left" class="demo-form-inline">
                    <el-form-item label="订单名称">
                        <el-input v-model="form.order_name" placeholder="订单名称" clearable @clear="orderList()"></el-input>
                    </el-form-item>
                    <el-form-item label="服务商">
                        <el-input v-model="form.sname" placeholder="服务商名称" clearable @clear="orderList()"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <el-input v-model="form.mobile" placeholder="手机号" clearable @clear="orderList()"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态">
                        <el-select v-model="form.order_status"  filterable placeholder="订单状态"  style="width: 150px;">
                            <el-option label="全部" value="-1"></el-option>
                            <el-option label="已支付" value="1"></el-option>
                            <el-option label="未支付" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
                <div class="total-box d_flex" style="margin-bottom: 20px;">
                    <div class="box-item" style="margin-right: 30px;font-size: 20px;color: #ff0000;font-weight: bold;"><span style="color: #333;font-size: 18px;font-weight: bold;margin-right: 5px">已支付总金额:</span>{{total_pay_money}}</div>
                    <div class="box-item" style="margin-right: 30px;font-size: 20px;color: #ff0000;font-weight: bold;"><span style="color: #333;font-size: 18px;font-weight: bold;margin-right: 5px">未支付总金额:</span>{{total_nopay_money||0}}</div>
                    <div class="box-item" style="margin-right: 30px;font-size: 20px;color: #ff0000;font-weight: bold;"><span style="color: #333;font-size: 18px;font-weight: bold;margin-right: 5px">本月已支付总金额:</span>{{total_month_money}}</div>
                    <div class="box-item" style="margin-right: 30px;font-size: 20px;color: #ff0000;font-weight: bold;"><span style="color: #333;font-size: 18px;font-weight: bold;margin-right: 5px">今日已支付总金额:</span>{{total_day_money}}</div>
                </div>
                <el-table
                        :data="tableData"
                        border
                        size="mini"
                        v-loading="loading"
                        style="width: 100%;text-align: center">
                    <el-table-column
                            prop="order_sn"
                            label="订单号"
                            align="center"
                            width="140">
                    </el-table-column>
                    <el-table-column
                            prop="order_name"
                            label="订单名称"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="user_name"
                            label="用户名称"
                            align="center"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="smobile"
                            label="用户手机号"
                            align="center"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="sname"
                            align="center"
                            width="180"
                            label="服务商名称">
                    </el-table-column>
                    <el-table-column
                            prop="stype"
                            align="center"
                            label="服务商类型">
                    </el-table-column>
                    <el-table-column
                            prop="create_time"
                            align="center"
                            width="180"
                            label="下单时间">
                    </el-table-column>
                    <el-table-column
                            prop="money"
                            align="center"
                            label="订单金额">
                        <template slot-scope="scope">
                            <span>{{scope.row.money}}元</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="pay_time"
                            align="center"
                            label="支付时间">
                    </el-table-column>
                    <el-table-column
                            prop="order_status"
                            align="center"
                            label="订单状态">
                        <template slot-scope="scope">
                            <span>{{scope.row.order_status|handleStatue}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            width="120"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="detail(scope.row)">详情</el-button>
                            <el-button v-if="role_id==1" type="text" size="small" @click="deleteRow(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pages"
                        :current-page="page"
 :page-size="20"
                        @current-change="handleCurrentChange"
                        style="margin-top: 20px; text-align: right;"
                >
                </el-pagination>
            </div>
        </div>
        <el-dialog title="分配详情" :visible.sync="detailPop">
            <el-table
                    :data="detailData"
                    v-loading="loading"
                    border
                    size="mini">
                <el-table-column prop="order_name" align="center" label="订单名"></el-table-column>
                <el-table-column prop="plat_income" align="center" label="平台收益"></el-table-column>
                <el-table-column prop="city_first_income" align="center" label="城市代理"></el-table-column>
<!--                <el-table-column prop="city_second_income" align="center" label="类型代理"></el-table-column>-->
                <el-table-column prop="referrer_income" align="center" label="推荐人"></el-table-column>
                <el-table-column prop="author_income" align="center" label="用户"></el-table-column>
                <el-table-column prop="create_time" align="center" label="创建时间"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closePop">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {orderList,delOrder} from '../../api/order'
    export default {
        name: "order",
        data() {
            return {
                role_id:0,
                tableData: [],
                detailData:[],
                pages:1,
                page:1,
                loading:true,
                form:{
                    order_status:'-1',
                    order_name:'',
                    sname:'',
                    mobile:'',
                },
                detailPop:false,
                total_pay_money:0,
                total_month_money:0,
                total_day_money:0,
            }
        },
        mounted(){
            this.role_id=localStorage.getItem('ROLE');
            this.orderList();
        },
        filters:{
            handleStatue(val){
                if(val==1){
                    return '已付款'
                }else if(val==0){
                    return '未付款'
                }
            }
        },
        methods:{
            orderList(){
                this.loading=true;
                orderList({
                        p:this.page,
                        ...this.form
                    }).then(res=>{
                        this.loading=false;
                    if(res.code==1){
                        this.total_pay_money=res.data.total_pay_money||0;
                        this.total_month_money=res.data.total_month_money||0;
                        this.total_day_money=res.data.total_day_money||0;
                        this.total_nopay_money=res.data.total_nopay_money||0;
                        this.tableData=res.data.list;
                        this.pages=res.data.total_num;
                    }
                })
            },
            onSubmit(){
                this.orderList();
            },
            handleCurrentChange(val){
                this.page = val;
                this.getAllianceList()
            },
            detail(row){
                this.detailPop=true;
                this.detailData.push(row);
            },
            closePop(){
                this.detailData=[];
                this.detailPop=false;
            },
            deleteRow(row){
                this.$confirm('此操作将永久删除该管理员, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delOrder({order_id:row.order_id}).then(res=>{
                        if(res.code==1){
                            this.$message.success('操作成功')
                            this.orderList();
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .page-content{
        padding: 20px;
        .table{
            background-color: #fff;
            padding: 20px;
            box-shadow: 0 4px 4px 0 #e1e5eb;
        }
    }
</style>
